<template>
  <div class="bottom-modal__wrap">
    <div class="pb-4">
      <h4>부고 전달 내용 확인 및 수정 후 방법을 선택해주세요</h4>
      <h4>(상단 메세지만 수정 가능합니다.)</h4>
    </div>

    <div
      class="bottom-modal__content obituary-share"
      style="flex-direction: column;"
    >
      <div
        class="obituary-share-box"
        style="cursor: default;"
        :class="{ active: !messageRelateType }"
      >
        <textarea v-model="titleareaComputed" style="white-space: pre-line; width: 100%; height: auto; resize: none;">
        </textarea>
      </div>
      <div
        class="obituary-share-box"
        style="cursor: default;"
        :class="{ active: !messageRelateType }"
      >
        <span style="max-width: 100%; white-space: pre-line; max-height: 100px; overflow: auto; word-break: break-all;">{{ onlyShow }}</span>
      </div>
    </div>
    <div
      v-if="
        getObituaryUser &&
        getObituaryUser.user_relation &&
        (getObituaryUser.user_company || getObituaryUser.user_position)
      "
      class="pb-2 text-start"
    >
      <input v-model="company_show" id="company_show" type="checkbox" />
      <label for="company_show"> 상주 회사명과 직책 / 직위 표시하기</label>
    </div>

    <div class="bottom-modal-icon__wrap obituary-share">
      <SnsIcon
        :class="{ active: snsType === 'kakao' }"
        :image="require('../../assets/images/obituary/kakao.svg')"
        title="카톡"
        @shareSns="snsType = 'kakao'"
      />
      <SnsIcon
        :class="{ active: snsType === 'sms' }"
        :image="require('../../assets/images/obituary/sms.svg')"
        title="문자"
        @shareSns="snsType = 'sms'"
      />

      <SnsIcon
        :class="{ active: snsType === 'band' }"
        :image="require('../../assets/images/obituary/band.svg')"
        title="밴드"
        @shareSns="snsType = 'band'"
      />
      <SnsIcon
        :class="{ active: snsType === 'copy' }"
        :image="require('../../assets/images/obituary/link_copy.svg')"
        title="복사"
        @shareSns="snsType = 'copy'"
      />
    </div>

    <div class="bottom-modal-button__wrap">
      <div class="bottom-modal-button close" @click="close">닫기</div>
      <div class="bottom-modal-button apply" @click="handleShare">공유하기</div>
    </div>

    <a ref="sms" :href="smsHref"></a>
  </div>
</template>

<script
  type="text/javascript"
  src="https://developers.kakao.com/sdk/js/kakao.js"
></script>
<script>
import { mapGetters } from "vuex";
import SnsIcon from "./SnsIcon.vue";

export default {
  name: "SnsList",
  components: { SnsIcon },
  data() {
    return {
      device: "",

      messageRelateType: true,
      snsType: "kakao",

      currentUrl: "",
      seqNo: this.$route.query.seq_no ? this.$route.query.seq_no : null,
      company_show: true,

      titlearea: "",
    };
  },

  computed: {
    ...mapGetters([
      "getObituary",
      "getObituaryUser",
      "getFamilies",
      "getObituaryFuneral",
    ]),

    titleareaComputed: {
      get() {
        return this.titlearea || (this.getObituaryUser && this.getObituaryUser.user_relation
          ? this.relationTitleTxt
          : this.defaultTitleTxt);
      },
      set(value) {
        this.titlearea = value;
      }
    },

    defaultTitleTxt() {
      return this.handleMakeDefaultTxt(`故 ${this.getObituary.DM_NAME}`);
    },
    userComapnyTxt() {
      if (!this.company_show) {
        return "";
      }

      if (
        this.getObituaryUser.user_company &&
        this.getObituaryUser.user_position
      ) {
        return `${this.getObituaryUser.user_company} ${this.getObituaryUser.user_position} `;
      }

      if (this.getObituaryUser.user_company) {
        return `${this.getObituaryUser.user_company} `;
      }

      if (this.getObituaryUser.user_position) {
        return `${this.getObituaryUser.user_position} `;
      }

      return "";
    },

    relationTitleTxt() {
      return this.handleMakeDefaultTxt(
        `${this.userComapnyTxt}${this.getObituaryUser.user_name}의 ${this.getObituaryUser?.user_relation} 故 ${this.getObituary.DM_NAME}`
      );
    },
    titleTxt() {
      return this.getObituaryUser?.user_relation && this.messageRelateType
        ? this.relationTitleTxt
        : this.defaultTitleTxt;
    },

    endTxt() {
      if (this.getObituary.FUNERAL_NAME.trim()) {
        return `본 메세지는 유가족들의 마음을 담아 ${this.getObituary.FUNERAL_NAME}에서 제작된 모바일 부고장입니다`;
      }
      return "";
    },

    memberListString() {
      if (this.getFamilies?.length > 0) {
        return this.getFamilies
          .map((item) => {
            const names = item.NAMES.replace(/빈빈빈|빈빈/g, "      ");
            return `${item.RELATION} : ${names}`;
          })
          .join("\n");
      }
      return "";
    },

    onlyShow() {
      let funeralInfo = `빈소 : ${this.getObituary.FUNERAL_NAME} / ${this.getObituary.APPELLATION}
오시는길 : ${this.getObituary.ADDRESS} / ${this.getObituary.CONTACT}`;

      return `${this.memberListString ? `상주정보
${this.memberListString}
` : ''}${funeralInfo}

■부고■
${this.currentUrl}

${this.endTxt}`;
    },

    kakaoBody() {
      let funeralInfo = `빈소 : ${this.getObituary.FUNERAL_NAME} / ${this.getObituary.APPELLATION}
오시는길 : ${this.getObituary.ADDRESS} / ${this.getObituary.CONTACT}`;
      const smsMessage = `■부고■
${this.currentUrl}

${this.titlearea}

■상주정보■
${this.memberListString}

${funeralInfo}

${this.endTxt}`;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return realSmsMessage;
    },

    smsBody() {
      let funeralInfo = `빈소 : ${this.getObituary.FUNERAL_NAME} / ${this.getObituary.APPELLATION}
오시는길 : ${this.getObituary.ADDRESS} / ${this.getObituary.CONTACT}`;
      let title = this.titlearea || (this.getObituaryUser && this.getObituaryUser.user_relation
      ? this.relationTitleTxt
      : this.defaultTitleTxt);
      const smsMessage = `${title}

${this.memberListString ? `상주정보
${this.memberListString}

` : ''}
${funeralInfo}

■부고■
${this.currentUrl}

${this.endTxt}`;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return encodeURIComponent(realSmsMessage);
    },

    smsBodyCopy() {
      let funeralInfo = `빈소 : ${this.getObituary.FUNERAL_NAME} / ${this.getObituary.APPELLATION}
오시는길 : ${this.getObituary.ADDRESS} / ${this.getObituary.CONTACT}`;
      let title = this.titlearea || (this.getObituaryUser && this.getObituaryUser.user_relation
      ? this.relationTitleTxt
      : this.defaultTitleTxt);

      const smsMessage = `${title}
${this.memberListString ? `
상주정보
${this.memberListString}
` : ''}
${funeralInfo}

■부고■
${this.currentUrl}

${this.endTxt}`;

      return smsMessage;
    },

    checkMobile() {
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    },

    smsHref() {
      console.log(this.smsBody)
      return (
        "sms:" +
        (this.checkMobile === "ios" ? "&" : "?") +
        "body=" +
        this.smsBody
      );
    },

    exShareFile() {
      const customFiles = this.getObituaryFuneral?.FuneralCustomFiles;

      if (!customFiles) {
        return null;
      }

      if (customFiles && customFiles?.length !== 0) {
        const shareFile = customFiles.filter((v) => v.custom_type == 4)[0];

        return shareFile;
      } else {
        return null;
      }
    },
  },

  mounted() {
    const device = navigator.userAgent.toLowerCase(); // userAgent 값 얻기

    if (device.includes("android")) {
      // 안드로이드
      this.device = "android";
    } else if (
      device.includes("iphone") ||
      device.includes("ipad") ||
      device.includes("ipod")
    ) {
      this.device = "ipone";
    } else {
      // 아이폰, 안드로이드 외 모바일
      this.device = "desktop";
    }

    this.currentUrl = window.location.href;
  },

  methods: {
    close() {
      this.$emit("close");
    },

    sendLinkKakao() {
      const templateArgs = {};
      let templateId = 103102;
      // let templateId = 99462;

      templateArgs[`SEQ_NO`] = this.seqNo;
      if (!this.getObituaryUser) {
        templateArgs[`QUERY`] = `event_no=${this.getObituary.EVENT_NO}`;
      }
      templateArgs[`TITLE`] = `[부고알림] ${this.getObituary.FUNERAL_NAME}`;
      templateArgs[`DESC`] = this.titlearea || (this.getObituaryUser && this.getObituaryUser.user_relation
      ? this.relationTitleTxt
      : this.defaultTitleTxt);
      if (this.exShareFile) {
        templateArgs[`THU`] = this.exShareFile.file_path;
        templateId = 103103;
        // templateId = 99463;
      }
      console.log(templateArgs)
      console.log(this.getObituary.APPELLATION);
      this.$kakao.Link.sendCustom({
        templateId,
        templateArgs,
      });
    },
    shareNaverBand() {
      const content = this.smsBody;
      const link = `http://band.us/plugin/share?body=${content}&route=${encodeURIComponent(
        this.currentUrl
      )}`;

      window.open(link, "share", "width=500, height=500");
    },
    async copyLink() {
      //const textToCopy = this.currentUrl;
      const textToCopy = this.smsBodyCopy;

      try {
        await navigator.clipboard.writeText(textToCopy);
        alert("클립보드에 복사되었습니다.");
      } catch (err) {
        if (!document.queryCommandSupported("copy")) {
          return alert("복사하기가 지원되지 않는 브라우저입니다.");
        }

        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.position = "fixed";

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("클립보드에 복사되었습니다.");
      }
    },

    handleMakeDefaultTxt(title) {
      let returnMsg = `${title}님께서 ${this.getObituary.DEAD_CLASSIFY} 하셨기에 부고를 전해 드립니다.`;
      return returnMsg;
    },

    handleShare() {
      switch (this.snsType) {
        case "kakao":
          this.sendLinkKakao();
          break;

        case "sms":
          this.$refs.sms.click();
          break;

        case "band":
          this.shareNaverBand();
          break;

        case "copy":
          this.copyLink();
          break;
        default:
          break;
      }

      this.close();
    },
  },
};
</script>

<style></style>
